import { render, staticRenderFns } from "./MainMenuNav.vue?vue&type=template&id=70c133a0&"
import script from "./MainMenuNav.vue?vue&type=script&lang=js&"
export * from "./MainMenuNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports